import DateRegisteredWithMyInstitution from './DateRegisteredWithMyInstitution';

export default DateRegisteredWithMyInstitution;
